import React, { useEffect } from "react";
import VideoContentActivityForm from "./VideoContentActivityForm";
import SelectCorrectImageActivityForm from "./SelectCorrectImageActivityForm";
import FillTheGapActivityForm from "./FillTheGapActivityForm";
import {
  CrossWordMatchQuestion,
  FillTheGapActivity,
  IActivitySwitch,
  SelectCorrectImageActivity,
  SingleWordMatchQuestion,
  TapWhatYouHearQuestion,
} from "../../types";
import SingleWordMatchActivityForm from "./SingleWordMatchActivityForm";
import CrossWordActivityForm from "./CrossWordActivityForm";
import TapWhatYouHearActivityForm from "./TapWhatYouHearActivityForm";
import { activityIdGenerator } from "@utils/storage.utils";

const ActivityFormWrapper = ({
  activityType,
  lessonMeta,
  initialActivity,
}: IActivitySwitch) => {
  /**
   * Generate activity ID based on the last activity ID stored in memory
   * Remove "LSN" prefix from lesson ID
   *  */
  let lessonIdWithoutLsn = "";
  if (lessonMeta?.lesson) {
    lessonIdWithoutLsn = lessonMeta?.lesson?.split("LSN")[1].slice(1) || "";
  } else {
    lessonIdWithoutLsn = "null";
  }

  const activityId = activityIdGenerator(lessonIdWithoutLsn);

  switch (activityType) {
    case "VideoContentActivity":
      return (
        <VideoContentActivityForm
          lessonMeta={lessonMeta}
          initialActivity={initialActivity}
          activityId={activityId}
        />
      );
    case "SelectCorrectImageActivity":
      return (
        <SelectCorrectImageActivityForm
          lessonMeta={lessonMeta}
          initialActivity={initialActivity as any as SelectCorrectImageActivity}
          activityId={activityId}
        />
      );
    case "TapInWhatYouHear":
      return (
        <TapWhatYouHearActivityForm
          lessonMeta={lessonMeta}
          initialActivity={initialActivity as any as TapWhatYouHearQuestion}
          activityId={activityId}
        />
      );
    case "FillTheGapActivity":
      return (
        <FillTheGapActivityForm
          lessonMeta={lessonMeta}
          initialActivity={initialActivity as any as FillTheGapActivity}
          activityId={activityId}
        />
      );
    case "MatchTheCorrectWord":
      return (
        <SingleWordMatchActivityForm
          lessonMeta={lessonMeta}
          initialActivity={initialActivity as any as SingleWordMatchQuestion}
          activityId={activityId as string}
        />
      );
    case "CrossWordActivity":
      return (
        <CrossWordActivityForm
          lessonMeta={lessonMeta}
          initialActivity={initialActivity as any as CrossWordMatchQuestion}
          activityId={activityId as string}
        />
      );
    default:
      return <p className="text-red-500">Unknown activity type selected</p>;
  }
};

export default ActivityFormWrapper;
